import React, { useState } from 'react';
import { BuildingIcon, CalendarIcon, PercentIcon, FileTextIcon } from 'lucide-react';
export function ProjectDetailsStep({
  initialData,
  onUpdate
}) {
  const [formData, setFormData] = useState({
    projectName: initialData.projectName || '',
    projectDescription: initialData.projectDescription || '',
    projectLocation: initialData.projectLocation || '',
    projectArea: initialData.projectArea || '',
    projectType: initialData.projectType || 'agriculture',
    salesProbability: initialData.salesProbability || '50',
    expectedClosingDate: initialData.expectedClosingDate || '',
    notes: initialData.notes || '',
    ...initialData
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  const handleBlur = () => {
    onUpdate(formData);
  };
  return <div className="space-y-6" data-id="element-4398">
      <div className="text-white text-xl font-medium mb-6" data-id="element-4399">Project Details</div>
      <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4400">
        <div className="flex items-center mb-4" data-id="element-4401">
          <FileTextIcon size={20} className="text-blue-400 mr-2" data-id="element-4402" />
          <h3 className="text-white font-medium" data-id="element-4403">Basic Information</h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-4404">
          <div data-id="element-4405">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-4406">
              Project Name
            </label>
            <input type="text" name="projectName" value={formData.projectName} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter project name" data-id="element-4407" />
          </div>
          <div data-id="element-4408">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-4409">
              Project Location
            </label>
            <input type="text" name="projectLocation" value={formData.projectLocation} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter location (city, country)" data-id="element-4410" />
          </div>
          <div className="md:col-span-2" data-id="element-4411">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-4412">
              Project Description
            </label>
            <textarea name="projectDescription" value={formData.projectDescription} onChange={handleChange} onBlur={handleBlur} rows={3} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Briefly describe the project" data-id="element-4413"></textarea>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4414">
        <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4415">
          <div className="flex items-center mb-4" data-id="element-4416">
            <BuildingIcon size={20} className="text-blue-400 mr-2" data-id="element-4417" />
            <h3 className="text-white font-medium" data-id="element-4418">Project Specifications</h3>
          </div>
          <div className="space-y-4" data-id="element-4419">
            <div data-id="element-4420">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4421">
                Project Area (hectares)
              </label>
              <input type="number" name="projectArea" value={formData.projectArea} onChange={handleChange} onBlur={handleBlur} min="0" step="0.01" className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter area in hectares" data-id="element-4422" />
            </div>
            <div data-id="element-4423">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4424">
                Project Type
              </label>
              <select name="projectType" value={formData.projectType} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
              backgroundSize: '20px'
            }} data-id="element-4425">
                <option value="agriculture" data-id="element-4426">Agriculture</option>
                <option value="greenhouse" data-id="element-4427">Greenhouse</option>
                <option value="golf" data-id="element-4428">Golf Course</option>
                <option value="sports" data-id="element-4429">Sports Fields</option>
                <option value="landscaping" data-id="element-4430">Landscaping</option>
                <option value="other" data-id="element-4431">Other</option>
              </select>
            </div>
            <div data-id="element-4432">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4433">Notes</label>
              <textarea name="notes" value={formData.notes} onChange={handleChange} onBlur={handleBlur} rows={3} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Additional notes about the project" data-id="element-4434"></textarea>
            </div>
          </div>
        </div>
        <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4435">
          <div className="flex items-center mb-4" data-id="element-4436">
            <CalendarIcon size={20} className="text-blue-400 mr-2" data-id="element-4437" />
            <h3 className="text-white font-medium" data-id="element-4438">Sales Information</h3>
          </div>
          <div className="space-y-4" data-id="element-4439">
            <div data-id="element-4440">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4441">
                Sales Probability (%)
              </label>
              <div className="flex items-center" data-id="element-4442">
                <input type="range" name="salesProbability" min="0" max="100" step="5" value={formData.salesProbability} onChange={handleChange} onBlur={handleBlur} className="w-full h-2 bg-slate-700 rounded-lg appearance-none cursor-pointer" data-id="element-4443" />
                <span className="ml-3 text-white font-medium min-w-[3rem] text-right" data-id="element-4444">
                  {formData.salesProbability}%
                </span>
              </div>
              <div className="flex justify-between text-xs text-blue-400 mt-1" data-id="element-4445">
                <span data-id="element-4446">Low</span>
                <span data-id="element-4447">Medium</span>
                <span data-id="element-4448">High</span>
              </div>
            </div>
            <div data-id="element-4449">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4450">
                Expected Closing Date
              </label>
              <div className="relative" data-id="element-4451">
                <input type="date" name="expectedClosingDate" value={formData.expectedClosingDate} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-4452" />
                <CalendarIcon size={18} className="absolute right-3 top-3 text-blue-400 pointer-events-none" data-id="element-4453" />
              </div>
            </div>
            <div className="bg-blue-900/30 rounded-lg p-4 mt-4" data-id="element-4454">
              <div className="flex items-start" data-id="element-4455">
                <PercentIcon size={18} className="text-blue-400 mr-2 mt-0.5" data-id="element-4456" />
                <div data-id="element-4457">
                  <h4 className="text-white text-sm font-medium mb-1" data-id="element-4458">
                    Sales Probability Guide
                  </h4>
                  <ul className="text-xs text-blue-300 space-y-1 list-disc pl-4" data-id="element-4459">
                    <li data-id="element-4460">0-25%: Initial contact, exploring options</li>
                    <li data-id="element-4461">26-50%: Engaged in discussions, some interest shown</li>
                    <li data-id="element-4462">51-75%: Serious interest, negotiating details</li>
                    <li data-id="element-4463">
                      76-100%: Highly likely to close, finalizing agreement
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}